import { render, staticRenderFns } from "./SettlementPeriods.vue?vue&type=template&id=c231840e&"
import script from "./SettlementPeriods.vue?vue&type=script&lang=js&"
export * from "./SettlementPeriods.vue?vue&type=script&lang=js&"
import style0 from "./SettlementPeriods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports